<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>统计管理</el-breadcrumb-item>
          <el-breadcrumb-item>按日统计</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box" :style="heightToolsBar">
        <div class="list-box">
          <div class="l-list">
            <el-button-group>
              <el-button
                type="primary"
                icon="el-icon-document-checked"
                @click="fileExport()"
                >导出</el-button
              >
            </el-button-group>
          </div>
          <div class="r-list">
            <div class="option">
              <cn-select-search
                v-model="companyId"
                :v_disabled="disabled"
                :v_whole="true"
                :data="companyList"
                @val="setCompanyId"
                placeholder="请筛选客户..."
              >
              </cn-select-search>

              <el-select v-model="cabinetId" placeholder="请选择设备...">
                <el-option :key="0" label="全部设备" :value="0"></el-option>
                <el-option
                  v-for="item in cabinetList"
                  :key="item.id"
                  :label="`${item.cabinetCode}  /  ${item.cabinetName}`"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-date-picker
                style="width: 280px"
                v-model="dateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
            <div class="search-box">
              <el-input
                placeholder="输入关健字"
                v-model="keyword"
                @keyup.enter.native="initData"
                v-show="false"
              >
              </el-input>
              <el-button
                type="primary"
                slot="append"
                icon="el-icon-search"
                @click="initData"
                style="float: right"
              ></el-button>
            </div>
            <div class="btn-box" v-show="false">
              <el-button-group>
                <el-button
                  type="primary"
                  :icon="iconToolsBar"
                  @click="toggleToolsBar"
                ></el-button>
              </el-button-group>
            </div>
          </div>
        </div>

        <div class="more-box">
          <dl>
            <dt>筛选设备</dt>
            <dd></dd>
          </dl>

          <dl>
            <dt>时间范围</dt>
            <dd></dd>
          </dl>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
            @selection-change="handleSelectionChange"
          >
            <el-table-column width="15"></el-table-column>
            <el-table-column label="客户名称">
              <template slot-scope="scope">
                <h4>
                  {{ scope.row.companyName }}
                </h4>
              </template>
            </el-table-column>
            <el-table-column
              prop="cabinetCode"
              label="设备编号"
            ></el-table-column>
            <el-table-column
              prop="cabinetName"
              label="设备标签"
            ></el-table-column>
            <el-table-column label="日期" width="84">
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.date }}</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="highTopChargePower"
              label="高尖充电量"
            ></el-table-column>
            <el-table-column
              prop="highTopDischargePower"
              label="高尖放电量"
            ></el-table-column>

            <el-table-column
              prop="topChargePower"
              label="尖时充电量"
            ></el-table-column>
            <el-table-column
              prop="topDischargePower"
              label="尖时放电量"
            ></el-table-column>

            <el-table-column
              prop="peakChargePower"
              label="峰时充电量"
            ></el-table-column>
            <el-table-column
              prop="peakDischargePower"
              label="峰时放电量"
            ></el-table-column>

            <el-table-column
              prop="flatChargePower"
              label="平时充电量"
            ></el-table-column>
            <el-table-column
              prop="flatDischargePower"
              label="平时放电量"
            ></el-table-column>

            <el-table-column
              prop="valleyChargePower"
              label="谷时充电量"
            ></el-table-column>
            <el-table-column
              prop="valleyDischargePower"
              label="谷时放电量"
            ></el-table-column>

            <el-table-column
              prop="totalChargePower"
              label="充电电量"
            ></el-table-column>
            <el-table-column
              prop="totalExpenditure"
              label="成本(元)"
              v-if="isShow"
            ></el-table-column>

            <el-table-column
              prop="totalDischargePower"
              label="放电电量"
            ></el-table-column>
            <el-table-column
              prop="totalIncome"
              label="收入(元)"
              v-if="isShow"
            ></el-table-column>

            <el-table-column
              prop="totalProfit"
              label="收益"
              v-if="isShow"
            ></el-table-column>
          </el-table>
        </el-card>

        <div class="pager-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax, getCompanyData } from "../../js/axios.config";
import "../../js/select.component.js";
export default {
  data() {
    return {
      isShow: false,
      disabled: false,
      cabinetId: "",
      companyId: "",
      companyList: [],
      cabinetList: [],
      showToolsBar: false, //显示更多条件选项
      heightToolsBar: "min-height:60px", //工具栏高度
      iconToolsBar: "iconfont icon-d-arrow-down", //更多按钮图标
      loading: false,
      orderType: -1,
      status: 0,
      keyword: "",
      dateRange: [],
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      listData: [],
    };
  },
  mounted() {},
  methods: {
    //初始化工具栏
    initLoad: function () {
      let _this = this;

      _this.companyList = getCompanyData();
      if (window.localStorage.getItem("fx_login_companyType") == "1") {
        _this.disabled = true;
        _this.companyId = window.localStorage.getItem("fx_login_companyId");
        _this.getCabinetList(_this.companyId);
      } else {
        _this.isShow = true;
      }
    },

    getCabinetList: function (companyId) {
      let _this = this; //当前页面
      _this.cabinetList = [];
      //加载设备列表
      AxiosAjax({
        url: "/cabinet/cabinet/page?index=1&size=9000&companyId=" + companyId,
        loading: true,
        success: function (res) {
          console.log(res.data.data);
          _this.cabinetList = res.data.data.content;
        },
      });
    },
    fileExport() {
      //下载

      let _this = this;

      let sendUrl = "/cabinet/cabinetChargeDischargeStatistic/dailyStatsExport";

      sendUrl += "?index=1";
      sendUrl += "&size=9999999";

      if (_this.companyId.length > 0 && _this.companyId != 0) {
        sendUrl += "&companyId=" + _this.companyId;
      }

      if (_this.cabinetId.length > 0 && _this.cabinetId != 0) {
        sendUrl += "&cabinetId=" + _this.cabinetId;
      }

      if (_this.dateRange.length > 0) {
        sendUrl += "&dateFrom=" + _this.dateRange[0];
        sendUrl += "&dateTo=" + _this.dateRange[1];
      }

      AxiosAjax({
        method: "down",
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          const contentType = res.headers["content-type"];
          let blob = new Blob([res.data], { type: contentType }); //生成blob文件
          const url = URL.createObjectURL(blob); //生成URL
          let a = document.createElement("a");
          a.href = url;
          a.download = "日报" + new Date().pattern("yyyyMMddHHmmss") + ".xlsx";
          a.click();
          a.remove();
          URL.revokeObjectURL(a.href);
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    //加载数据
    initData: function () {
      let _this = this;
      let sendUrl = "/cabinet/cabinetChargeDischargeStatistic/dailyStatsPage";

      sendUrl += "?index=" + _this.pageIndex;
      sendUrl += "&size=" + _this.pageSize;

      if (_this.companyId.length > 0 && _this.companyId != 0) {
        sendUrl += "&companyId=" + _this.companyId;
      }

      if (_this.cabinetId.length > 0 && _this.cabinetId != 0) {
        sendUrl += "&cabinetId=" + _this.cabinetId;
      }

      if (_this.dateRange.length > 0) {
        sendUrl += "&dateFrom=" + _this.dateRange[0];
        sendUrl += "&dateTo=" + _this.dateRange[1];
      }

      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data.content;
          _this.totalCount = res.data.data.total;
          // _this.pageSize = res.data.data.size;
          _this.pageIndex = res.data.data.index;
        },
        error: function (err) {
          _this.listData = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    //切换更多查询条件
    toggleToolsBar: function () {
      this.showToolsBar = !this.showToolsBar;
      if (this.showToolsBar) {
        this.heightToolsBar = "height:auto";
        this.iconToolsBar = "iconfont icon-d-arrow-up";
      } else {
        this.heightToolsBar = "height:60px";
        this.iconToolsBar = "iconfont icon-d-arrow-down";
      }
    },

    //选中第几行
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
    },
    setCompanyId: function (obj) {
      this.companyId = obj.toString();
      this.getCabinetList(this.companyId);
    },
  },
  created: function () {
    //初始化工具栏
    this.initLoad();
    if (this.$route.params.companyId) {
      this.companyId = this.$route.params.companyFullName;
      this.setCompanyId(this.$route.params.companyId);
      this.cabinetId = this.$route.params.cabinetId;
    }
    //加载数据
    this.initData();
  },
};
</script>
<style scoped>
.content-box .table-list .nowrap {
  white-space: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/Report/DailyList.vue